import React, { useState } from 'react';
import { useAuth } from '../../../context/AuthContext';
import { authService } from '../../../services/auth.service';
import styles from './ProfilePage.module.scss';

const ProfilePage: React.FC = () => {
    const { user } = useAuth();
    const [firstname, setFirstname] = useState(user?.firstname || '');
    const [lastname, setLastname] = useState(user?.lastname || '');
    const [email, setEmail] = useState(user?.email || '');
    const [phone, setPhone] = useState('');
    const [address, setAddress] = useState('');
    const [cp, setCp] = useState('');
    const [city, setCity] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setMessage('');
        setError('');

        const token = localStorage.getItem('token');
        if (!token) return;

        try {
            await authService.updateProfile(token, {
                firstname, lastname, email, phone, address, cp, city
            });
            setMessage('Profil mis à jour avec succès');
        } catch (err: any) {
            setError(err.response?.data?.message || 'Erreur lors de la mise à jour');
        }
    };

    return (
        <div className={styles.profile}>
            <h1>Mon Profil</h1>
            
            {message && <div className={styles.success}>{message}</div>}
            {error && <div className={styles.error}>{error}</div>}

            <form onSubmit={handleSubmit} className={styles.form}>
                <div className={styles.row}>
                    <div className={styles.field}>
                        <label>Prénom</label>
                        <input type="text" value={firstname} onChange={(e) => setFirstname(e.target.value)} />
                    </div>
                    <div className={styles.field}>
                        <label>Nom</label>
                        <input type="text" value={lastname} onChange={(e) => setLastname(e.target.value)} />
                    </div>
                </div>
                <div className={styles.field}>
                    <label>Email</label>
                    <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                </div>
                <div className={styles.field}>
                    <label>Téléphone</label>
                    <input type="tel" value={phone} onChange={(e) => setPhone(e.target.value)} />
                </div>
                <div className={styles.field}>
                    <label>Adresse</label>
                    <input type="text" value={address} onChange={(e) => setAddress(e.target.value)} />
                </div>
                <div className={styles.row}>
                    <div className={styles.field}>
                        <label>Code Postal</label>
                        <input type="text" value={cp} onChange={(e) => setCp(e.target.value)} />
                    </div>
                    <div className={styles.field}>
                        <label>Ville</label>
                        <input type="text" value={city} onChange={(e) => setCity(e.target.value)} />
                    </div>
                </div>
                <button type="submit" className={styles.submitBtn}>Sauvegarder</button>
            </form>
        </div>
    );
};

export default ProfilePage;
